import React from 'react';
import { NextSeo } from 'next-seo';
import { NextSeoProps } from 'next-seo';
import { OpenGraphMedia, OpenGraphArticle, OpenGraphProfile } from 'next-seo/lib/types';

const Seo = ({ type, data }: SeoPropTypes) => {
  const { title, description, path, image, baseUrl, ...rest } = data;

  const seoConfig: NextSeoProps = {
    title,
    description,
    canonical: `https://${baseUrl}${path}`,
    openGraph: {
      url: `https://${baseUrl}${path}`,
      type,
      title,
      description,
      site_name: 'ELEVATOR',
      ...rest,
    },
  };

  if (image && seoConfig.openGraph) seoConfig.openGraph.images = [image];

  return <NextSeo {...seoConfig} />;
};

export type SeoOGType = 'website' | 'article' | 'profile';

export type SeoData = {
  baseUrl: string;
  title: string;
  description?: string;
  path: string;
  image?: OpenGraphMedia;
  profile?: OpenGraphProfile;
  article?: OpenGraphArticle;
};

export type SeoPropTypes = {
  type: SeoOGType;
  data: SeoData;
};

export default Seo;
